'use es6';

export const CMV2_CAN_CREATE_HTML_FIELD = 'DesignManager:IDE:CMv2:canCreateHTMLField';
export const CMV2_CAN_CREATE_HUBL_FIELD = 'DesignManager:IDE:CMv2:canCreateHublField';
export const CMV2_CAN_CREATE_SURVEY_FIELD = 'ServiceHub:Feedback:CMv2:SurveyField';
export const HIDE_DOMAIN_STYLESHEET = 'DesignManager:IDE:hideDomainStylesheet';
export const LAYOUT_WIDGET_HELP_TEXT = 'DesignManager:IDE:LayoutEditor:WidgetHelpText';
export const JS_RAW_ASSET_CREATION = 'DesignManager:IDE:JSRawAssetCreation';
export const SHOW_LAYOUT_SECTION_EDITOR_OPTIONS = 'DesignManager:IDE:ShowLayoutSectionEditorOptions';
export const SHOW_LAYOUT_LOCALIZATION = 'DesignManager:IDE:LayoutEditor:LayoutLocalization'; // Toggle button for `layout.bodyEditable`

export const LAYOUT_EDITOR_VIRTUAL_BODY_FIELD = 'DesignManager:IDE:LayoutEditor:BodyEditable';
export const MODULE_ID_MIGRATION = 'DesignManager:ModuleIdMigration';
export const LAYOUT_WIDGET_PREFER_PATH_KEY = 'DesignManager:LayoutWidgetPreferPathKey';
export const HUBL_V3_GATE = 'Email:HubLSupport';
export const SERVERLESS_PACKAGES = 'DesignManager:ServerlessPackages';
export const PROJECTS = 'DesignManager:Projects';
export const MODULE_STYLE_FIELDS = 'DesignManager:ModuleStyleFields';
export const PAYMENTS_BETA = 'Payments:Beta';
export const DFS_PROJECTS = 'DFS:Projects';
export const EMAIL_BUSINESS_UNIT_GATE = 'campaign-business-unit';
export const USE_CONTENT_TYPES = 'CMv2:UseContentTypes';
export const CUSTOM_THEME_CHILD_CREATION = 'DesignManager:CustomThemeChildCreation';
export const FOLLOWUP_EMAIL_IN_FORM_FIELD = 'ContextualAutomation:FollowupEmailInFormField';
export const MODULE_CATEGORIES = 'CMv2:ModuleCategories';
export const DND_AREAS_IN_CUSTOM_TEMPLATES = 'Email:DndAreasInCustomEditor';